import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

type CreateArticlePreviewProps = {
  artistId: string;
  articleId: string;
};

type ArticlePreviewResponse = {
  token: string;
  expires_at: string;
};

export type ArticlePreviewLink = {
  token: string;
  expiresAt: string;
};

/**
 * A one-hour link that shows the article, in any status, on pray.com's own article page
 * (`/articles/preview/<token>`). Anyone allowed to read the article in Studio can ask for one.
 */
export async function createArticlePreview({
  artistId,
  articleId,
}: CreateArticlePreviewProps): Promise<ArticlePreviewLink> {
  if (!artistId) throw Error('Artist ID is required');
  if (!articleId) throw Error('Article ID is required');

  const url = `/web/studio/artists/${artistId}/articles/${articleId}/preview`;
  const response = await api.executePostRequest<ObjectResponse<ArticlePreviewResponse>>(url);
  // The HTTP response's body is the API's envelope; the link is its `data`.
  const { data } = response.data;

  return { token: data.token, expiresAt: data.expires_at };
}
